import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { axiosPrivate } from "../../axios/axios";
import Loading from "../../Component/Loading";
import { masterAPI } from "../Masters/dataConfig";
import { getCurrentYearInTimeZone } from "../../utils/dateUtil";

const MaintenanceKPIDetailChart = ({
  legendColors = "black",
  xAxisLabelColor = "black",
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const currentYear = getCurrentYearInTimeZone();
      const link = masterAPI.KPIReport.getKPIMaintenance;
      const response = await axiosPrivate.post(`${link}?year=${currentYear}`);
      const result = response.data?.result || response.data || null;
      setData(result);
    } catch (err) {
      console.log(err, "MaintenanceKPIDetailChart fetch error");
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  const months = data?.months || [];
  const startedCount = data?.startedCount || [];
  const backlogCount = data?.backlogCount || [];
  const workorderCount = data?.workorderCount || [];

  const series = [
    {
      name: "WO Done",
      type: "column",
      data: startedCount,
    },
    {
      name: "WO Backlog",
      type: "column",
      data: backlogCount,
      color: "#D32F2F",
    },
    {
      name: "WO Plan",
      type: "line",
      data: workorderCount,
      color: "#2362B4",
    },
  ];

  const options = {
    chart: {
      type: "line",
      height: 350,
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
        export: {
          csv: { filename: "Maintenance KPI Detail" },
          svg: { filename: "Maintenance KPI Detail" },
          png: { filename: "Maintenance KPI Detail" },
        },
      },
    },
    title: {
      text: "Maintenance KPI",
      align: "center",
      style: {
        fontFamily: "Nunito Sans, sans-serif",
        color: "#2362B4",
        fontSize: "15px",
        fontWeight: 600,
      },
    },
    stroke: {
      width: [0, 0, 3],
      curve: "straight",
    },
    markers: {
      size: [0, 0, 5],
      strokeWidth: 2,
      hover: { size: 7 },
    },
    plotOptions: {
      bar: {
        borderRadius: 3,
        horizontal: false,
        columnWidth: "60%",
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [0, 1, 2],
      offsetY: -6,
      style: {
        fontSize: "11px",
        fontFamily: "Nunito Sans, sans-serif",
        colors: ["#333333"],
      },
      background: { enabled: false },
      dropShadow: { enabled: false },
    },
    xaxis: {
      categories: months,
      labels: {
        style: {
          colors: xAxisLabelColor,
          fontFamily: "Nunito Sans, sans-serif",
        },
      },
      title: {
        text: "Months",
        style: { fontFamily: "Nunito Sans, sans-serif" },
      },
    },
    yaxis: {
      title: {
        text: "Values",
        style: { fontFamily: "Nunito Sans, sans-serif" },
      },
      labels: {
        formatter: (val) => Math.round(val),
      },
    },
    legend: {
      position: "bottom",
      labels: { colors: legendColors },
      fontFamily: "Nunito Sans, sans-serif",
    },
    noData: {
      text: "No Data Available",
      align: "center",
      verticalAlign: "middle",
      style: {
        color: "#999",
        fontSize: "14px",
        fontFamily: "Nunito Sans, sans-serif",
      },
    },
    responsive: [
      {
        breakpoint: 1024,
        options: { chart: { height: 300 } },
      },
      {
        breakpoint: 768,
        options: { chart: { height: 250 } },
      },
    ],
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Chart options={options} series={series} type="line" height={350} />
      )}
    </>
  );
};

export default MaintenanceKPIDetailChart;
